// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainWrapper__PACMv {
  display: flex;
  justify-content: space-between;
  background: var(--tables-main-surface);
}

.contentBlock__bqq5T {
  width: 100%;
  flex: 1;
  overflow-y: auto;
  height: 100dvh;
  min-height: 100dvh;
  z-index: 2;
  background: var(--tables-main-surface);
  position: relative;
}
.contentBlock__bqq5T::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.contentBlock__bqq5T::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.contentBlock__bqq5T::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.contentBlock__bqq5T::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 810px) {
  .contentBlock__bqq5T {
    width: 93%;
  }
}

@media (max-width: 810px) {
  .fullSidebar__Xwayd {
    width: 77%;
  }
}

.onBoardBlock__DKxC6 {
  overflow: hidden;
}
@media (max-width: 800px) {
  .onBoardBlock__DKxC6 {
    width: 75%;
  }
}

.toastContainer__INYLM {
  top: 55px;
  right: 25px;
  padding: 0;
  width: 700px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: absolute;
  transition: width 150ms ease-in-out;
}
@media (max-width: 950px) {
  .toastContainer__INYLM {
    width: 70%;
  }
}
@media (max-width: 800px) {
  .toastContainer__INYLM {
    right: 25px;
    width: 560px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/Root/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,8BAAA;EACA,sCAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,OAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,sCAAA;EACA,kBAAA;AAzEF;AAWE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AATJ;AAYE;EACE,+BAAA;EACA,kBAAA;AAVJ;AAaE;EACE,8BAAA;EACA,kBAAA;AAXJ;AAcE;EACE,gBAAA;EACA,kBAAA;AAZJ;AA4DE;EAZF;IAaI,UAAA;EAzDF;AACF;;AA6DE;EADF;IAEI,UAAA;EAzDF;AACF;;AA4DA;EACE,gBAAA;AAzDF;AA0DE;EAFF;IAGI,UAAA;EAvDF;AACF;;AA0DA;EACE,SAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mCAAA;AAvDF;AAyDE;EAXF;IAYI,UAAA;EAtDF;AACF;AAwDE;EAfF;IAgBI,WAAA;IACA,YAAA;EArDF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.mainWrapper {\n  display: flex;\n  justify-content: space-between;\n  background: var(--tables-main-surface);\n}\n\n.contentBlock {\n  width: 100%;\n  flex: 1;\n  overflow-y: auto;\n  height: 100dvh;\n  min-height: 100dvh;\n  z-index: 2;\n  background: var(--tables-main-surface);\n  position: relative;\n\n  @include scrollBar;\n\n  @media (max-width: 810px) {\n    width: 93%;\n  }\n}\n\n.fullSidebar {\n  @media (max-width: 810px) {\n    width: 77%;\n  }\n}\n\n.onBoardBlock {\n  overflow: hidden;\n  @media (max-width: 800px) {\n    width: 75%;\n  }\n}\n\n.toastContainer {\n  top: 55px;\n  right: 25px;\n  padding: 0;\n  width: 700px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  position: absolute;\n  transition: width 150ms ease-in-out;\n\n  @media (max-width: 950px) {\n    width: 70%;\n  }\n\n  @media (max-width: 800px) {\n    right: 25px;\n    width: 560px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainWrapper": `mainWrapper__PACMv`,
	"contentBlock": `contentBlock__bqq5T`,
	"fullSidebar": `fullSidebar__Xwayd`,
	"onBoardBlock": `onBoardBlock__DKxC6`,
	"toastContainer": `toastContainer__INYLM`
};
module.exports = ___CSS_LOADER_EXPORT___;
